import { Splash } from './../assets';
export const SPLASH_ARRAY = [{
    title: 'Welcome to My Yodlee.',
    text: 'A new experience designed to help you respond to customer tickets faster.',
    centerImage: Splash.EntrySplash,
},
{
    title: 'Meet your new home page, a customizable dashboard.',
    text: 'Manage daily tasks and workflows more efficiently with easy-to-use tiles.',
    centerImage: Splash.Dashboard,
    sideImage: Splash.MenuDashboard
},
{
    title: 'Find “case management” and more in the new “Service requests” page.',
    text: 'Explore the new automated support tool and enjoy improved search, filter and sort options.',
    centerImage: Splash.SR,
    sideImage: Splash.MenuSR
},
{
    title: 'Understand customers better with data on the new “Customers” page.',
    text: 'Drive adoption and revenue with visibility to consumer engagement analytics.',
    centerImage: Splash.Customers,
    sideImage: Splash.MenuCustomer
},
{
    title: 'Access “Site information” using the new “Sites” page.',
    text: 'Monitor site health across institution sites and the Envestnet | Yodlee Platform more easily.',
    centerImage: Splash.Sites,
    sideImage: Splash.MenuSites
},
{
    title: 'Stay current with “Notifications” using the new “Status” page.',
    text: 'Track incidents, progress, event resolution, and maintenance easily with a new timeline view.',
    centerImage: Splash.Status,
    sideImage: Splash.MenuStatus
}];
